import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import "./PersonInfo.css";



const PersonInfo = () => {
  // const initialval = '';
  const [first_name, setFirst_name] = useState("");
  const [last_name, setLast_name] = useState("");
  const [email, setEmail] = useState("");
  const [isPending, setIsPending] = useState(false);

  const history = useHistory();

  const handleSubmitName = (e) => {
    e.preventDefault();
    const blog = { first_name, last_name, email };
    setIsPending(true);
    fetch(`${process.env.REACT_APP_BASE_URL}/myprofile`, {
      method: "PUT",
      body: blog,
      credentials: "include",
    })
      .then((data) => data.json())
      .then((res) => {
        setIsPending(false);
        if (res.status === "success") {
          // window.location.reload()
          history.push("/");
        } else {
          alert(res.msg);
        }
      });
  };

  return (
    <div className="personinfo">
      <div className="container container-custom">
        <div className="container-inside-person">
          <div className="personinfo-top">
            <h1>Personal Information</h1>
            <form onSubmit={handleSubmitName}>
              <div className="form-group form-group-custom">
                <label>First Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={first_name}
                  // value={first_name || ''}
                  // value={first_name ?? ""}
                  // refs={this.input}
                  onChange={(e) => setFirst_name(e.target.value)}
                />
              </div>
              <div className="form-group form-group-custom">
                <label>Last Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={last_name}
                  onChange={(e) => setLast_name(e.target.value)}
                />
              </div>
              <div className="form-group form-group-custom">
                <label>Email Address</label>
                <input
                  type="email"
                  className="form-control"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <button className="but-full-width">Save</button>
            </form>
          </div>

          <div className="personinfo-bottom">
            <h1>Password</h1>
            <form>
              <div className="form-group form-group-custom">
                <label htmlFor="currentpassword">Current Password</label>
                <input
                  type="password"
                  className="form-control"
                  id="currentpassword"
                />
              </div>
              <div className="form-group form-group-custom">
                <label htmlFor="newpassword">New Password</label>
                <input
                  type="password"
                  className="form-control"
                  id="newpassword"
                />
              </div>
              <div className="form-group form-group-custom">
                <label htmlFor="confirmnewpassword">Confirm New Password</label>
                <input
                  type="password"
                  className="form-control"
                  id="confirmnewpassword"
                />
              </div>
              <button className="but-full-width">Change Password</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonInfo;
